import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    billList: [],
    billTypes: [],
    totalCount: 0,
    pagination: {
      page: 1,
      size: 10
    }
  },
  getters: {},
  mutations: {
    setpage(state, page) {
      state.pagination = page;
    },
    setUserBillList(state, payload) {
      state.billList = payload.list;
      state.totalCount = payload.totalCount;
    },
    setBillTypeList(state, payload) {
      state.billTypes = payload;
    }
  },
  actions: {
    reReset(context, data) {
      return api.reReset(data);
    },
    getUserBillList({ commit }, content) {
      api.getUserBillList(content).then(({ data }) => {
        commit('setUserBillList', data);
      });
    },
    listBillType({ commit }) {
      api.getBillTypeList().then(({ data }) => {
        commit('setBillTypeList', data);
      });
    }
  }
};

appStore.registerModule('overtime', store);
